import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { distance } from '@turf/turf';
import { pointerMove } from 'ol/events/condition';
import { Select } from 'ol/interaction';
import { toLonLat } from 'ol/proj';
import { useSelector, useDispatch } from 'react-redux';

import actions from '@/actions';
import OlMap from '@/helpers/OlMap';

const useMission = (robot) => {
  const dispatch = useDispatch();
  const controlPayloads = useSelector((state) => state.telemetry[robot.id].controlPayloads);
  const dockOsdStatus = useSelector((state) => state.telemetry[robot.id].dockOsdStatus);
  const commands = useSelector((state) => state.missions[robot.id]?.commands);
  const map = OlMap.getMap();

  useUpdateEffect(() => {
    OlMap.removeWays(robot.id);
    drawCommand();
  }, [controlPayloads, dockOsdStatus]);

  useUpdateEffect(() => {
    drawCommand();

    return () => {
      OlMap.removeWays(robot.id);
    };
  }, [commands, robot.color]);

  const drawCommand = () => {
    if (!commands) return;

    // 마커 정의
    const markers = [];
    commands.forEach((command, index) => {
      switch (command.type) {
        case 'navTakeoff':
        case 'navWaypoint':
          markers.push({
            position: command.data.position,
            label: index + 1,
          });
          break;

        case 'navReturnToLaunch': {
          let homePosition = null;
          if (controlPayloads) {
            homePosition = {
              lat: controlPayloads.home_latitude,
              lng: controlPayloads.home_longitude,
            };
          } else if (dockOsdStatus) {
            homePosition = {
              lat: dockOsdStatus.latitude,
              lng: dockOsdStatus.longitude,
            };
          }

          if (!homePosition) break;
          markers.push({
            position: homePosition,
            label: index + 1,
          });
          break;
        }

        default:
          break;
      }
    });
    const { paths } = OlMap.addWays(robot.id, markers, robot.color);

    // Mouse over 시 강조
    const handleHover = new Select({
      condition: pointerMove,
      layers: [paths],
    });
    handleHover.on('select', (e) => {
      if (e.selected.length) {
        const { flatCoordinates } = e.selected[0].values_.geometry;
        const distanceValue =
          1000 *
          distance(
            toLonLat([flatCoordinates[0], flatCoordinates[1]]),
            toLonLat([flatCoordinates[2], flatCoordinates[3]])
          );

        dispatch(actions.callout.setText(`${distanceValue.toFixed(1)}m`));
      } else {
        dispatch(actions.callout.setText(null));
      }
    });
    map.addInteraction(handleHover);
  };
};

export default useMission;
